module.exports = __webpack_public_path__ + "images/talkingDog.0ecaf9bb.svg";